import { createSlice } from '@reduxjs/toolkit'
import { PERMISSION_STATES } from '../../../../utils/permissions-service'

const initialState = {
  newPermission: PERMISSION_STATES.PROMPT,
  positionErrorMsg: '',
  geoPosition: {},
  position: {
    lat: null,
    lng: null
  }
}

export const geolocationSlice = createSlice({
  name: 'geolocation',
  initialState,
  reducers: {
    updateGeolocation: (state, action) => {
      const {
        newPermission,
        positionErrorMsg,
        geoPosition,
        position
      } = action.payload

      state.geoPosition = geoPosition
      state.position = position
      state.newPermission = newPermission
      state.positionErrorMsg = positionErrorMsg
    },

    // Use when GPS fails transiently (timeout, unavailable) — keeps existing position intact
    updateGeolocationError: (state, action) => {
      const { positionErrorMsg } = action.payload
      state.positionErrorMsg = positionErrorMsg
    },

    // Full reset including permission. Dispatched on delivery mount so a
    // second delivery starts from a clean state even if the first left a
    // persisted/permanent DENIED.
    resetGeolocation: () => initialState,

    // The browser's own answer for the site permission. Set on mount and on
    // Retry GPS so a granted driver without a position yet is not sent to the
    // permission modal (26635).
    updatePermission: (state, action) => {
      state.newPermission = action.payload
    }
  }
})

export const { updateGeolocation, updateGeolocationError, updatePermission, resetGeolocation } = geolocationSlice.actions

export const selectGeolocation = (state) => state.geolocation

export default geolocationSlice.reducer
